import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AxiosInstance from "../../api/AxiosInstance";
import {
  reset,
  updateBatch,
} from "../../redux/CreateBatchandGroup/CreateBatchGroup";
import Styles from "./_admin-login.module.css";
import Select from "react-select";
import Creatable from "react-select/creatable";

const UpdateBatch = () => {
  let { Success } = useSelector(state => state.auth);

  let { batchCode } = useParams();

  let [trainers, setTrainers] = useState([]);
  let [Jtrainers, setJtrainers] = useState([]);

  let [courses, setCourses] = useState([]);
  let [subjects, setSubjects] = useState([]);
  let [branches, setBranches] = useState([]);

  let [batchcode, setBatchCode] = useState("");
  let [subject, setSubject] = useState("");
  let [course, setCourse] = useState("");
  let [branch, setBranch] = useState("");

  let [trainer, setTrainer] = useState("");
  let [jounior, setJounior] = useState([]);
  let [juniorTrainer, setJuniorTrainer] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  // let [tracker, setTracker] = useState("");
  let [addStudents, setAddStudents] = useState(Array);
  let [errors, setErrors] = useState({});
  let [data, setData] = useState("");

  // const handleSelect = (value) => {
  //
  //   setSelectedOption(option);
  // };
  // //(Jtrainers);
  // //(jounior);

  // setSelectedOption1(selectedOptionObjects);
  useEffect(() => {
    const option = trainers.find(e => e.value === trainer);
    // //(option);
    setSelectedOption(option);

    let aa = Jtrainers.map(x => x.value.username);

    let data = aa.filter(element => jounior.includes(element));
  });
  const selectedIndices = [];
  Jtrainers.forEach((option, index) => {
    if (jounior.includes(option.value.username)) {
      selectedIndices.push(index);
    }
  });

  let dispatch = useDispatch();
  let { isError, isSuccess, message } = useSelector(
    state => state.createBatchgroup
  );
  let navigate = useNavigate();
  let { userAdmin } = useSelector(state => state.auth);

  useEffect(() => {
    async function fetchlist() {
      AxiosInstance.get(`admin/batchList/batchdata/${batchCode}`, {
        headers: {
          Authorization: `Bearer ${userAdmin.TOKEN}`,
        },
      }).then(data => {
        let batch = data?.data?.batchData?.batchCode;
        let subje = data?.data?.batchData?.subject;
        let cour = data?.data?.batchData?.course;
        let bran = data?.data?.batchData?.branch;
        let train = data?.data?.batchData?.trainer;
        let junior = data?.data?.batchData?.juniorTrainer;

        setBatchCode(batch);
        setSubject(subje);
        setCourse(cour);
        setBranch(bran);
        setTrainer(train);
        // setJuniorTrainer(junior)

        let bbb = junior.map(function (ele) {
          return ele.username;
        });
        setJounior(bbb);
      });
    }
    fetchlist();
  }, []);
  useEffect(() => {
    async function fetchData() {
      // get Subjects
      let Subjectdata = await AxiosInstance.get(`auth/getdata?data=subject`, {
        headers: {
          Authorization: `Bearer ${userAdmin.TOKEN}`,
        },
      });
      let Subjectdataaa = Subjectdata?.data[0].subject;
      let ddd = Subjectdataaa.map(function (ele) {
        return { value: ele, label: ele };
      });
      setSubjects(ddd);
    }
    fetchData();
  }, [userAdmin._id]);
  useEffect(() => {
    async function fetchData() {
      // // get Course
      let Coursedata = await AxiosInstance.get(`auth/getdata?data=course`, {
        headers: {
          Authorization: `Bearer ${userAdmin.TOKEN}`,
        },
      });

      let Coursedataaa = Coursedata?.data[0].course;
      let eee = Coursedataaa.map(function (ele) {
        return { value: ele, label: ele };
      });
      setCourses(eee);
    }
    fetchData();
  }, [userAdmin._id]);

  useEffect(() => {
    async function fetchData() {
      // // get branch
      let Branchdata = await AxiosInstance.get(`auth/getdata?data=branch`, {
        headers: {
          Authorization: `Bearer ${userAdmin.TOKEN}`,
        },
      });

      let Branchdataaa = Branchdata?.data[0]?.branch;
      let ccc = Branchdataaa?.map(function (ele) {
        return { value: ele, label: ele };
      });
      setBranches(ccc);
    }
    fetchData();
  }, [userAdmin._id]);

  useEffect(() => {
    async function fetchData() {
      let trainerdata = await AxiosInstance.get(
        `auth/getusersrole?role=trainer`,
        {
          headers: {
            Authorization: `Bearer ${userAdmin.TOKEN}`,
          },
        }
      );
      let trainersss = trainerdata?.data?.usersDetails;
      let aaa = trainersss.map(function (ele) {
        return { value: ele.username, label: ele.username };
      });
      let bbb = trainersss.map(function (ele) {
        return { value: ele, label: ele.username };
      });
      setTrainers(aaa);
      setJtrainers(bbb);
    }
    fetchData();
  }, [userAdmin._id, Success === true]);

  useEffect(() => {
    if (isError) {
      toast.error(message.message, {
        position: "top-right",
      });
      dispatch(reset());
    }
    if (isSuccess) {
      toast.success("Batch added successfully", { position: "top-right" });
      dispatch(reset());
      navigate("/admin-dashboard");
    }
  }, [isSuccess, isError]);

  let onChangeselect = e => {
    if (e?.value) {
      setSubject(e.value);
    } else {
      setSubject("");
    }
  };
  let ChangeCourse = e => {
    if (e?.value) {
      setCourse(e.value);
    } else {
      setCourse("");
    }
  };
  const handleChange = e => {

    if (e?.value) {
      setTrainer(e.value);
    } else {
      setTrainer("");
    }
  };

  const handleChangeBranch = e => {
    if (e?.value) {

      setBranch(e.value);
    } else {
      setBranch("");
    }
  };

  let handleSubmit = e => {
    e.preventDefault();
    try {
      let formData = new FormData();
      formData.append("file", addStudents);
      formData.append("batchCode", batchCode);
      formData.append("subject", subject);
      formData.append("course", course);
      formData.append("branch", branch);
      formData.append("trainer", trainer);
      formData.append("juniorTrainer", JSON.stringify(juniorTrainer));

      dispatch(updateBatch(formData));
    } catch (error) {
      //(error);
    }

  };
  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <section id={Styles.createBatch}>
      <article>
        <div className={Styles.container}>
          <h1>Update Batch</h1>
          <form onSubmit={handleSubmit} className={Styles.createBatchForm}>
            <div>
              <div className={Styles.formgroup}>
                <label htmlFor="batchcode">BatchCode</label>
                <input
                  className="form-control"
                  type="text"
                  name="batchcode"
                  // required
                  readOnly
                  value={batchcode}
                  placeholder="Enter Batchcode"
                  onChange={e => setBatchCode(e.target.value)}
                />
                {errors.batchcode && (
                  <p className={Styles.errors}>{errors.batchcode}</p>
                )}
              </div>
              <div className={Styles.trainer1}>
                <label htmlFor="subject">subject</label>

                <Select
                  isClearable
                  isSearchable
                  placeholder={subject}
                  escapeClearsValue={true}
                  labelKey="name"
                  className={Styles.option}
                  options={subjects}
                  onChange={onChangeselect}
                />
                <p
                  className={
                    errors.subject ? `${Styles.errrr}` : `${Styles.gapbtw}`
                  }
                ></p>

                {errors.subject && (
                  <p className={Styles.errors}>{errors.subject}</p>
                )}
              </div>
              <div className={Styles.trainer1}>
                <label htmlFor="course">course</label>

                <Creatable
                  placeholder={course}
                  isClearable
                  className={Styles.option}
                  options={courses}
                  onChange={ChangeCourse}
                />
                <p
                  className={
                    errors.course ? `${Styles.errrr}` : `${Styles.gapbtw}`
                  }
                ></p>
                {errors.course && (
                  <p className={Styles.errors}>{errors.course}</p>
                )}
              </div>
              <div className={Styles.trainer1}>
                <label htmlFor="branch">branch</label>

                <Creatable
                  placeholder={branch}
                  className={Styles.option}
                  options={branches}
                  onChange={handleChangeBranch}
                />
                <p
                  className={
                    errors.branch ? `${Styles.errrr}` : `${Styles.gapbtw}`
                  }
                ></p>

                {errors.branch && (
                  <p className={Styles.errors}>{errors.branch}</p>
                )}
              </div>
              {/* ----------------------trainer------------------------------- */}
              <div className={Styles.trainer}>
                <label htmlFor="trainer">Trainer </label>

                <Creatable
                  placeholder={trainer}
                  // value={trainer}
                  value={selectedOption}
                  isClearable
                  options={trainers}
                  onChange={handleChange}
                  labelKey="name"
                />
                <p
                  className={
                    errors.trainer ? `${Styles.errrr}` : `${Styles.gapbtw}`
                  }
                ></p>
                {errors.trainer && (
                  <p className={Styles.errors}>{errors.trainer}</p>
                )}
              </div>

              {/* --------------------------juniour trainer -------------------------*/}

              <div className={Styles.trainer}>
                <label htmlFor="juniorTrainer">Junior Trainer </label>

                {/* <Select
                  placeholder={jounior.join(", ")}
                  closeMenuOnSelect={false}
                  defaultValue={defaultValue}
                  options={Jtrainers}
                  isMulti
                  name="students"
                  onChange={handleChangeJtrainer}
                /> */}
                <Select
                  placeholder={jounior.join(", ")}
                  closeMenuOnSelect={false}
                  isMulti
                  name="students"
                  options={Jtrainers}
                  onChange={e => {
                    setJuniorTrainer(
                      Array.isArray(e)
                        ? e.map(x => ({
                            _id: x.value._id,
                            username: x.value.username,
                          }))
                        : []
                    );
                  }}
                />
              </div>

              {/* <div className={Styles.formgroup}>
                <label>Upload Your File </label>
                <input
                  type="file"
                  id="addStudents"
                  name="addStudents"
                  onChange={e => setAddStudents(e.target.files[0])}
                />
                {errors.addStudents && (
                  <p className={Styles.errors}>{errors.addStudents}</p>
                )}
               
              </div> */}
            </div>
            <aside className={Styles.createButton}>
              <button
                style={{ background: "red", border: "1px solid red" }}
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button>Update Batch</button>
            </aside>
          </form>
        </div>
      </article>
    </section>
  );
};

export default UpdateBatch;
